<template>
  <div class="wdqb-box" v-if="data">
    <div class="wdqb-content">
      <!-- 左侧：钱包信息 -->
      <div class="wdqb-left">
        <!-- 币种卡片 -->
        <div class="wdqb-coin-card">
		  <img :src="data.currencyLogo" alt="" class="wdqb-coin-icon"/>
          <div class="wdqb-coin-info">
            <span class="wdqb-coin-name">{{data.currencyName}}</span>
            <span class="wdqb-coin-desc">{{$t('all.lianshangbaobishibei')}}</span>
          </div>
        </div>
        <!-- 余额信息 -->
        <div class="wdqb-item">
          <span class="wdqb-item-label">{{$t('all.zonge')}}</span>
          <span class="wdqb-item-value">{{data.sumAmount}} {{data.currencyName}}</span>
        </div>
        <div class="wdqb-item">
          <span class="wdqb-item-label">{{$t('all.keyongshuliang')}}</span>
          <span class="wdqb-item-value">{{data.sumAvailableAmount}} {{data.currencyName}}</span>
        </div>
        <div class="wdqb-item">
          <span class="wdqb-item-label">{{$t('all.dongjieshuliang')}}</span>
          <span class="wdqb-item-value">{{data.sumFreezeAmount}} {{data.currencyName}}</span>
        </div>
        <!-- 操作按钮 -->
        <div class="wdqb-actions">
          <div :class="activeTab === 'deposit' ? 'wdqb-action-btn wdqb-action-gradient' : 'wdqb-action-btn'" @click="handleSwitchDeposit">{{$t('all.chongbi')}}</div>
          <div :class="activeTab === 'withdraw' ? 'wdqb-action-btn wdqb-action-gradient' : 'wdqb-action-btn'" @click="handleSwitchWithdraw">{{$t('all.tibi')}}</div>
        </div>
        <!-- 查看流水 -->
        <div class="wdqb-flow-btn" @click="handleGoFlow">{{$t('all.chakanliushui')}}</div>
      </div>
      <!-- 右侧面板 -->
      <div class="wdqb-right" v-if="activeTab">
        <!-- 充币面板 -->
        <template v-if="activeTab === 'deposit'">
          <!-- <div class="wdqb-right-item">
            <span class="wdqb-right-label">{{$t('all.dizhi')}}</span>
            <div class="wdqb-right-item-right">
              <span class="wdqb-right-value wdqb-text-green">{{formatAddress(data.rechargeAddress)}}</span>
              <img src="../../../assets/image/fuzhi_18@2x.png" alt="" @click="handleCopyAddress"/>
            </div>
          </div> -->
          <div class="wdqb-right-item">
            <span class="wdqb-right-label">{{$t('all.wangluo')}}</span>
            <span class="wdqb-right-value wdqb-text-green" v-if="data.rechargeNetworkConfigList && data.rechargeNetworkConfigList[0]">{{data.rechargeNetworkConfigList[0].symbol}}</span>
          </div>
          <div class="wdqb-right-tip">{{$t('all.chongzhitip')}}</div>
          <div class="wdqb-right-item">
            <span class="wdqb-right-label">{{$t('all.chongzhishuliang')}}</span>
            <input class="wdqb-right-input" v-model="depositAmount" :placeholder="$t('all.shuru')" />
          </div>
          <div class="wdqb-right-min-tip" v-if="data.rechargeNetworkConfigList && data.rechargeNetworkConfigList[0] && !depositError">{{$t('all.zuidicharge')}}{{data.rechargeNetworkConfigList[0].minRechargeAmount}} {{data.currencyName}}</div>
          <div class="wdqb-right-error" v-if="depositError">{{depositError}}</div>
          <div class="wdqb-right-estimate">
            <span class="wdqb-right-estimate-title">{{$t('all.yujidaozhang')}}</span>
            <div class="wdqb-right-estimate-card">
              <span class="wdqb-right-estimate-label">{{$t('all.shijidaozhang')}}</span>
              <span class="wdqb-right-estimate-num">{{depositActual}} {{data.currencyName}}</span>
            </div>
            <div class="wdqb-right-estimate-info">
              <span>{{$t('all.chongzhishuliang')}} {{depositAmount || '0'}} {{data.currencyName}}</span>
              <span>{{$t('all.shouxufei')}} {{depositFee}} {{data.currencyName}} ({{data.rechargeServiceChargeRatio ? (data.rechargeServiceChargeRatio * 100) : 0}}%)</span>
            </div>
          </div>
          <div class="wdqb-right-btn" @click="handleRecharge">{{$t('all.lijichongzhi')}}</div>
        </template>
        <!-- 提币面板 -->
        <template v-if="activeTab === 'withdraw'">
          <div class="wdqb-right-item">
            <span class="wdqb-right-label">{{$t('all.tibidizhi')}}</span>
            <input class="wdqb-right-input" v-model="withdrawAddress" :placeholder="$t('all.qingshurutibidizhi')" />
          </div>
          <div class="wdqb-right-item">
            <span class="wdqb-right-label">{{$t('all.wangluo')}}</span>
            <span class="wdqb-right-value">{{data.withdrawalNetworkConfigList[0].symbol}}</span>
          </div>
          <div class="wdqb-right-item">
            <span class="wdqb-right-label">{{$t('all.tibishuliang')}}</span>
            <input class="wdqb-right-input" v-model="withdrawAmount" :placeholder="$t('all.qingshuru')" />
          </div>
          <div class="wdqb-right-min-tip" v-if="data.withdrawalNetworkConfigList[0].minWithdrawalAmount">{{$t('all.zuiditixianjin')}}{{data.withdrawalNetworkConfigList[0].minWithdrawalAmount}} {{data.currencyName}}</div>
          <div class="wdqb-right-error" v-if="withdrawError">{{withdrawError}}</div>
          <div class="wdqb-right-estimate">
            <div class="wdqb-right-estimate-header">
              <span class="wdqb-right-estimate-title">{{$t('all.tibishisuan')}}</span>
              <span class="wdqb-right-estimate-tag">{{$t('all.shouxufeibilv')}}{{data.withdrawalNetworkConfigList[0].withdrawalServiceChargeRatio}}</span>
            </div>
            <div class="wdqb-right-estimate-row">
              <span>{{$t('all.shouxufei')}}</span>
              <span>{{withdrawFee}} {{data.currencyName}}</span>
            </div>
            <div class="wdqb-right-estimate-row">
              <span>{{$t('all.shijidaozhang')}}</span>
              <span class="wdqb-text-green">{{withdrawActual}} {{data.currencyName}}</span>
            </div>
          </div>
          <div class="wdqb-right-btn" @click="handleWithdraw">{{$t('all.tijiaotibi')}}</div>
        </template>
      </div>
    </div>

    <!-- 选择提币地址弹框 -->
    <div class="wdqb-overlay" v-if="showAddressModal" @click="showAddressModal = false"></div>
    <div class="wdqb-address-modal" v-if="showAddressModal" @click.stop>
      <div class="wdqb-address-title">{{$t('all.xuanzetibidizhi')}}</div>
      <div class="wdqb-address-search">
		<img class="wdqb-address-search-icon" src="../../../assets/image/sousuo_18@2x.png" alt=""/>
        <input class="wdqb-address-search-input" v-model="searchAddress" :placeholder="$t('all.sousuodizhi')" />
      </div>
      <div class="wdqb-address-list">
        <div class="wdqb-address-item" v-for="(item, index) in addressList" :key="index">
          <div class="wdqb-address-item-info">
            <span class="wdqb-address-item-label">{{item.label}}</span>
            <span class="wdqb-address-item-value">{{item.address}}</span>
          </div>
          <div class="wdqb-address-item-btn" @click="handleSelectAddress(item)">{{$t('all.xuanze')}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserWalletInfo,toWithdrawal } from "@/api/qianbao";
export default {
  data() {
    return {
	  data:'',
      activeTab: '',
      showAddressModal: false,
      searchAddress: '',
      addressList: [
        { label: '常用地址', address: '0x82...8F91' },
        { label: '交易所地址', address: '0x82...8F91' },
        { label: '冷钱包', address: '0x82...8F91' },
      ],
      depositAmount: '',
      depositError: '',
      depositFee: '0.00',
      depositActual: '0.00',
      withdrawAmount: '',
      withdrawAddress: '',
      withdrawFee: '0.00',
      withdrawActual: '0.00',
      withdrawError: ''
    };
  },
  mounted() {
  	this.getUserWalletInfo()
  },
  watch: {
    depositAmount(val) {
      this.calculateDeposit(val);
    },
    withdrawAmount(val) {
      // 限制输入小数位数（最多contractDecimals位）
      if (val && val.includes('.')) {
        const maxDecimals = parseInt(this.data && this.data.contractDecimals) || 18;
        const parts = val.split('.');
        if (parts[1] && parts[1].length > maxDecimals) {
          this.withdrawAmount = parts[0] + '.' + parts[1].slice(0, maxDecimals);
          return;
        }
      }
      this.calculateWithdraw(val);
    }
  },
  methods: {
	async getUserWalletInfo(){
	  const res = await getUserWalletInfo({currencyId:this.$route.query.currencyId})
	  this.data = res.data
	  // 根据配置设置默认 tab
	  const hasRecharge = this.data.rechargeNetworkConfigList && this.data.rechargeNetworkConfigList.length > 0;
	  const hasWithdraw = this.data.withdrawalNetworkConfigList && this.data.withdrawalNetworkConfigList.length > 0;
	  if (hasRecharge) {
	    this.activeTab = 'deposit';
	  } else if (hasWithdraw) {
	    this.activeTab = 'withdraw';
	  } else {
	    this.activeTab = '';
	  }
	},
    calculateWithdraw(val) {
      this.withdrawError = '';
      this.withdrawFee = '0.00';
      this.withdrawActual = '0.00';

      if (!val || parseFloat(val) <= 0) {
        return;
      }

      const amount = parseFloat(val);
      const minAmount = parseFloat(this.data.withdrawalNetworkConfigList[0].minWithdrawalAmount || 0);
      const maxAmount = parseFloat(this.data.withdrawalNetworkConfigList[0].maxWithdrawalAmount || -1);
      const availableAmount = parseFloat(this.data.sumAvailableAmount || 0);
      const feeRatio = parseFloat(this.data.withdrawalNetworkConfigList[0].withdrawalServiceChargeRatio || 0);
      const decimals = parseInt(this.data.contractDecimals) || 18;

      if (amount < minAmount) {
        this.withdrawError = this.$t('all.zuiditixianjin') + minAmount + ' ' + this.data.currencyName;
        return;
      }

      if (maxAmount !== -1 && amount > maxAmount) {
        this.withdrawError = this.$t('all.meiriyushutixian') + maxAmount + ' ' + this.data.currencyName;
        return;
      }

      if (amount > availableAmount) {
        this.withdrawError = this.$t('all.keyongyu') + availableAmount + ' ' + this.data.currencyName;
        return;
      }

      const fee = amount * feeRatio;
      const actual = amount - fee;

      this.withdrawFee = this.truncateDecimal(fee, decimals);
      this.withdrawActual = this.truncateDecimal(actual, decimals);
    },
    // 截取小数位（不四舍五入），并去掉末尾多余的零
    truncateDecimal(num, decimals) {
      const d = decimals !== undefined ? decimals : 18;
      if (d === 0) return Math.floor(num).toString();
      // 先用合理精度 round 掉浮点误差（最多保留 contractDecimals 位，但计算用 10 位精度去除浮点噪声）
      const safePrecision = Math.min(d, 10);
      const rounded = parseFloat(num.toFixed(safePrecision));
      // 再按 contractDecimals 截取（向下取整）
      const factor = Math.pow(10, safePrecision);
      const truncated = Math.floor(rounded * factor) / factor;
      // 转字符串并去掉末尾多余的零，最少保留2位
      let result = truncated.toFixed(safePrecision);
      const dotIndex = result.indexOf('.');
      if (dotIndex !== -1) {
        let end = result.length - 1;
        while (end > dotIndex + 2 && result[end] === '0') {
          end--;
        }
        result = result.slice(0, end + 1);
      }
      return result;
    },
    handleGoFlow() {
      this.$router.push({ path: '/liushuijilu',query: {
        currencyId: this.data.currencyId,
        unitText:this.data.currencyName
      }});
    },
    handleSwitchDeposit() {
      if (!this.data.rechargeNetworkConfigList || this.data.rechargeNetworkConfigList.length === 0) {
        this.$message.warning(this.$t('all.gaibizhongbuzhichichongzhi'));
        return;
      }
      this.activeTab = 'deposit';
    },
    handleSwitchWithdraw() {
      if (!this.data.withdrawalNetworkConfigList || this.data.withdrawalNetworkConfigList.length === 0) {
        this.$message.warning(this.$t('all.gaibizhongbuzhichitibi'));
        return;
      }
      this.activeTab = 'withdraw';
    },
    handleCopyAddress() {
      navigator.clipboard.writeText('0x82...8F91');
      this.$message.success(this.$t('all.fuzhichenggong'));
    },
    calculateDeposit(val) {
      this.depositError = '';
      this.depositFee = '0.00';
      this.depositActual = '0.00';

      if (!val || parseFloat(val) <= 0) {
        return;
      }

      const amount = parseFloat(val);
      const rechargeConfig = this.data.rechargeNetworkConfigList && this.data.rechargeNetworkConfigList[0];
      const minAmount = parseFloat(rechargeConfig && rechargeConfig.minRechargeAmount || 0);
      const feeRatio = parseFloat(rechargeConfig && rechargeConfig.rechargeServiceChargeRatio || this.data.rechargeServiceChargeRatio || 0);
      const decimals = parseInt(this.data.contractDecimals) || 18;

      if (minAmount > 0 && amount < minAmount) {
        this.depositError = this.$t('all.zuidicharge') + minAmount + ' ' + this.data.currencyName;
        return;
      }

      const fee = amount * feeRatio;
      const actual = amount - fee;

      this.depositFee = this.truncateDecimal(fee, decimals);
      this.depositActual = this.truncateDecimal(actual, decimals);
    },
    handleRecharge() {
      if (!this.depositAmount || parseFloat(this.depositAmount) <= 0) {
        this.$message.warning(this.$t('all.shuru'));
        return;
      }
      if (this.depositError) {
        this.$message.warning(this.depositError);
        return;
      }
	  console.log(this.data)
      const rechargeConfig = this.data && this.data.rechargeNetworkConfigList && this.data.rechargeNetworkConfigList[0];
      if (!rechargeConfig) {
        this.$message.warning('该币种暂不支持充值');
        return;
      }
	  this.$router.push({ path: '/chongzhierweima',query: {
	    amount: this.depositAmount,
	    blockchainNetworkConfigId: rechargeConfig.blockchainNetworkConfigId || ''
	  }});
    },
    async handleWithdraw() {
      if (!this.withdrawAddress) {
        this.$message.warning(this.$t('all.qingshurutibidizhi'));
        return;
      }
      if (!this.withdrawAmount || parseFloat(this.withdrawAmount) <= 0) {
        this.$message.warning(this.$t('all.qingshuru'));
        return;
      }
      if (this.withdrawError) {
        this.$message.warning(this.withdrawError);
        return;
      }
	  const res = await toWithdrawal({
		  blockchainNetworkConfigId: this.data.withdrawalNetworkConfigList[0].blockchainNetworkConfigId,
		  amount: this.withdrawAmount,
		  address: this.withdrawAddress
	  })
	  this.$message.success(res.msg);
	  this.withdrawAmount = '';
	  this.withdrawAddress = '';
	  this.getUserWalletInfo()
    },
    handleSelectAddress(item) {
      this.showAddressModal = false;
      this.$router.push('/querentbi');
    },
    formatAddress(address) {
      if (!address) return '';
      if (address.length <= 10) return address;
      return address.slice(0, 6) + '...' + address.slice(-4);
    }
  }
};
</script>

<style scoped lang="scss">
@import "./wodequanbao.css";
</style>



// WEBPACK FOOTER //
// wodequanbao.vue?a0abc110